export const AUDIT_LOG_SERVICE_ENDPOINT = window.env.VUE_APP_AUDIT_LOG_SERVICE_DOMAIN;

// Resource paths
export const LOG_RESOURCE_PATH = '/log';
